export function useHandleMissingImage() {
  const handleMissingImage = (event) => {
    event.target.src = '/images/midheaven-missing-image.webp'
  }

  return {
    handleMissingImage,
  }
}
